<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <label class="searchItemName">统计日期：</label>
        <el-date-picker v-model="queryParams.dateRange" type="daterange" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels
          :picker-options="pickerOptions"></el-date-picker>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button type="primary" icon="el-icon-download" @click="ExportTable()">下载统计数据</el-button>
    </div>
    <div ref="chart" class="page-chart" v-show="chartData.length"></div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;" show-summary :summary-method="getSummary">
      <el-table-column prop="date" label="日期" min-width="120" align="center"></el-table-column>
      <el-table-column prop="photoCount" label="拍照次数" min-width="110" align="center"></el-table-column>
      <el-table-column prop="payCount" label="支付笔数" min-width="110" align="center"></el-table-column>
      <el-table-column prop="amountTotal" label="支付金额" min-width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.amountTotal) }}</template>
      </el-table-column>
      <el-table-column prop="refundCount" label="退款笔数" min-width="110" align="center"></el-table-column>
      <el-table-column prop="refundAmount" label="退款金额" min-width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.refundAmount) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'
import Excel from '../../../../public/tools/exportExcelHelp.js'

function formatDay(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function defaultDayRange() {
  const end = new Date()
  const start = new Date()
  start.setDate(start.getDate() - 14)
  return [formatDay(start), formatDay(end)]
}

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      channels: [],
      queryParams: { pageIndex: 1, pageSize: 10, channelId: '', dateRange: defaultDayRange() },
      tableData: [],
      chartData: [],
      chart: null,
      pickStart: null,
      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          this.pickStart = maxDate ? null : minDate
        },
        disabledDate: (time) => {
          if (!this.pickStart) return false
          const start = new Date(this.pickStart)
          const min = new Date(start)
          min.setMonth(min.getMonth() - 3)
          const max = new Date(start)
          max.setMonth(max.getMonth() + 3)
          return time.getTime() < min.getTime() || time.getTime() > max.getTime()
        }
      }
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  mounted() {
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const range = this.queryParams.dateRange || []
      if (!range[0] || !range[1]) {
        this.$message.warning('请选择统计日期，最长跨度3个月')
        return
      }
      const loading = this.openLoading()
      post(601, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        beginTime: range[0],
        endTime: range[1]
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.chartData = Array.isArray(data.chart) && data.chart.length ? data.chart : this.tableData
          this.total = Number(data.pageCount) || 0
          this.$nextTick(() => this.renderChart())
        } else {
          this.tableData = []
          this.chartData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.chartData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    renderChart() {
      if (!this.$refs.chart) return
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      const rows = this.chartData
      this.chart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['拍照次数', '支付金额(元)'] },
        xAxis: { type: 'category', data: rows.map(x => x.date) },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: [
          { name: '拍照次数', type: 'bar', data: rows.map(x => x.photoCount) },
          { name: '支付金额(元)', type: 'line', yAxisIndex: 1, data: rows.map(x => (x.amountTotal || 0) / 100) }
        ]
      }, true)
    },
    resizeChart() {
      if (this.chart) this.chart.resize()
    },
    getSummary({ columns }) {
      const data = this.chartData || []
      return columns.map((col, index) => {
        if (index === 0) return '合计'
        const key = col.property
        if (key === 'amountTotal' || key === 'refundAmount') {
          return this.formatMoney(data.reduce((s, r) => s + (r[key] || 0), 0))
        }
        return data.reduce((s, r) => s + (Number(r[key]) || 0), 0)
      })
    },
    ExportTable() {
      const range = this.queryParams.dateRange || []
      if (!range[0] || !range[1]) {
        this.$message.warning('请选择统计日期后再导出')
        return
      }
      const loading = this.openLoading()
      post(601, {
        pageIndex: 1,
        pageSize: 500,
        channelId: this.queryParams.channelId || 0,
        beginTime: range[0],
        endTime: range[1]
      }).then(response => {
        loading.close()
        if (response.data.result != 0) {
          this.$message.error('导出失败：' + response.data.message)
          return
        }
        const list = (response.data.data && response.data.data.chart) || []
        if (!list.length) {
          this.$message.warning('没有可导出的数据')
          return
        }
        const rows = list.map(item => Object.assign({ '日期': item.date }, Excel.metricFields(item)))
        rows.push(Object.assign({ '日期': '合计' }, Excel.metricTotal(list)))
        Excel.ExportExcel(rows, Excel.fileName('每日统计', range[0], range[1]))
        this.$message.success('导出成功')
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || '导出失败')
      })
    }
  }
}
</script>
